/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Button from '@salesforce/design-system-react/components/button';
import { BrowserRouter as Router, RouteComponentProps, withRouter } from 'react-router-dom';
import { getEventIconInner } from '../../../util/utilityFunctions';

interface EventId {
  caseExternalId: string;
  eventId: string;
  caseNumber: string;
  orderId: string;
  parentEventId: string;
  parentEventType: any;
  caseId: string;
  parentCaseExternalId: string;
  parentCaseId: string;
}

// interface for props that the data table cell is getting default from data table.
export interface Props extends RouteComponentProps {
  children?: FC;
  item?: EventId;
  type?: string;
}

const OrderRequestIdCell: FC<Props> = ({
  item = {
    caseExternalId: null,
    orderId: null,
    eventId: null,
    caseNumber: null,
    parentEventId: null,
    parentEventType: null,
    caseId: null,
    parentCaseExternalId: null,
    parentCaseId: null,
  },
  history,
  // type = null,
}) => {
  const { parentEventId, parentEventType, parentCaseExternalId, parentCaseId } = item;

  const goToSurgicalDetail = (): void => {
    history.push('/surgicalDetails', {
      eventType: parentEventType,
      externalId: parentCaseExternalId,
      id: parentCaseId,
    });
  };
  const iconPath = getEventIconInner(parentEventType);

  return (
    <Router>
      <DataTableCell title={parentEventId || ''}>
        {parentEventId ? (
          <>
            <img src={iconPath} className="logo-image" alt="company" />
            <Button
              style={{ margin: '5px 5px 5px 5px' }}
              label={parentEventId || ''}
              variant="base"
              onClick={goToSurgicalDetail}
            />
          </>
        ) : (
          '--'
        )}
      </DataTableCell>
    </Router>
  );
};

export default withRouter(OrderRequestIdCell);
